import { render, staticRenderFns } from "./paymentPoolList.vue?vue&type=template&id=38bafe90&scoped=true"
import script from "./paymentPoolList.vue?vue&type=script&lang=js"
export * from "./paymentPoolList.vue?vue&type=script&lang=js"
import style0 from "./paymentPoolList.vue?vue&type=style&index=0&id=38bafe90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bafe90",
  null
  
)

export default component.exports